import React from 'react';
import { useNavigate } from 'react-router-dom';
import BackIcon from '../../../components/Icons/BackIcon';
import DocumentIcon from '../../../components/Icons/DocumentIcon';
import CheckIcon from '../../../components/Icons/CheckIcon';
import AlertIcon from '../../../components/Icons/AlertIcon';
import CountDownIcon from '../../../components/Icons/CountDownIcon';
import DownloadIcon from '../../../components/Icons/DownloadIcon';
import { useExportInventoryRequest, useExportInventoryDiscrepanciesRequest } from '../../../hooks/useApi';
import './ReportHeader.css';

export const ReportHeader = ({inventoryId, inventoryName, posId, total, issues, resolved, remaining}) =>
{
  const navigate = useNavigate();
  const [{ loading: exportLoading }, exportInventory] = useExportInventoryRequest(posId);
  const [{ loading: exportDiscrepancyLoading }, exportInventoryDiscrepancy] = useExportInventoryDiscrepanciesRequest(posId);
  
  const handleExport = async () =>
  {
    const response = await exportInventory({ bodyParams: { inventoryId: parseInt(inventoryId, 10) } });
    if (response?.data)
    {
      const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inventory-${inventoryId}-export.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  const handleExportDiscrepancies = async () =>
  {
    const response = await exportInventoryDiscrepancy({ bodyParams: { inventoryId: parseInt(inventoryId, 10) } });
    if (response?.data)
    {
      const blob = new Blob([response.data], { type: response.headers?.['content-type'] || 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `inventory-${inventoryId}-discrepancies.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="report-header">
      <div className="report-header-top">
        <button className="disc-back-btn" onClick={() => navigate(`/inventory-management/${inventoryId}`)}>
          <BackIcon/>
        </button>

        <div className="disc-title-block">
          <div className="disc-subtitle">{inventoryName || 'Inventory'}</div>
          <h1 className="disc-title">Inventory Report</h1>
        </div>

        <div className="disc-stats-bar">
          <div className="disc-stat-pill">
            <DocumentIcon width={25} height={25} color='#2B7FFF'/>
            Total <span className="disc-stat-value">{total}</span>
          </div>
          <div className="disc-stat-pill">
            <AlertIcon width={25} height={25} color='#D4183D'/>
            Issues <span className="disc-stat-value">{issues}</span>
          </div>
          <div className="disc-stat-pill">
            <CheckIcon width={25} height={25} color='#10B981'/>
            Resolved <span className="disc-stat-value">{resolved}</span>
          </div>
          <div className="disc-stat-pill">
            <CountDownIcon width={25} height={25} color='#F97316'/>
            Remaining <span className="disc-stat-value">{remaining}</span>
          </div>
        </div>

        <button
          className="report-export-btn"
          onClick={handleExport}
          disabled={exportLoading}
        >
          <DownloadIcon width={16} height={16} color='#111827'/>
          {exportLoading ? 'Exporting...' : 'Export All'}
        </button>

        <button
          className="report-export-btn"
          onClick={handleExportDiscrepancies}
          disabled={exportDiscrepancyLoading}
        >
          <DownloadIcon width={16} height={16} color='#111827'/>
          {exportDiscrepancyLoading ? 'Exporting...' : 'Export Discrepancies'}
        </button>
      </div>

      <div className="report-header-divider"/>
    </div>
  );
};
